import {useHistory} from "react-router-dom";
import {useState, useEffect, useContext, useRef} from 'react';
import {useQuery} from "react-query";
import {completeReplenishment, addProductToReplenishment, fetchFreeLocationsForReplenishment, fetchReplenishment, searchProductInReplenishment, receiveProduct, receiveReplenishment, damagedProduct as updateDamagedProduct, correctProduct, updateQualityCheck, updateReplenishmentStatus, getSupplierInvoices} from "../../services";
import {
    Button,
    ButtonLoader,
    Checkbox,
    FilterMenu,
    SmallTable,
    SearchInput,
    InputQuantity,
    PageView,
    ConfirmDialog,
    DialogView,
    Notification,
    BasicTable
} from "../../components";
import {getSkus} from "../../components/utils/productUtils";
import { useParams } from "react-router-dom";
import {UserContext} from "../../hooks/UserContext";
import { InputNumber, Tooltip } from "antd"
import { CreateLotsDialog } from "./CreateLotsDialog";
import { SupplierInvoiceChip } from "../ReplenishmentBoxes/SupplierInvoiceChip";
import { InvoiceQuantityChips } from "../ReplenishmentBoxes/InvoiceQuantityChips";
import { buildReceivedProductRows } from "./receivedProductRows";
import { SupplierInvoiceSection } from "./ShowReplenishmentSupplierInvoices";
import { buildCorrectionPayload, clampInvoiceCorrectionQuantity, invoiceCorrectionsTotal } from "./invoiceCorrections";
import { SupplierInvoiceFiles } from "../ReplenishmentBoxes/SupplierInvoiceFiles";
import moment from 'moment';
import { fetchReplenishmentPaginated } from "../../services/replenishmentServices";
import { InboundAppointmentSection } from "./InboundAppointmentSection";
import { useDispatch, useSelector } from "react-redux";
import { setReplenishmentsProductsListPageSize } from "../../redux/pageSizeSlice";
import { useTranslation } from "react-i18next";
import { ClipboardCheckIcon, ExclamationCircleIcon, XIcon } from "@heroicons/react/outline";

export const ShowReplenishment = () => {
    const history = useHistory()
    const { i18n } = useTranslation()


    const [textToSearch, setTextToSearch] = useState("")
    const [messageProductsNotFound, setProductsNotFound] = useState(false)
    const [exists, setExists] = useState(false)
    const [productSearchIsLoading, setproductSearchIsLoading] = useState(false)
    const [foundProducts, setFoundProducts] = useState([])
    const [foundLots, setFoundLots] = useState([])
    const [correctedProduct, setCorrectedProduct] = useState(null)
    const [selectLocationId, setSelectLocationId] = useState(null)
    const [insertQuantity, setInsertQuantity] = useState(1)
    const [correctQuantity, setCorrectQuantity] = useState(0)
    const [insertNumberOfBoxes, setInsertNumberOfBoxes] = useState(1)
    const [loadingButton, setLoadingButton] = useState(false)
    const [loadingCompleteButton, setLoadingCompleteButton] = useState(false)
    const [loadingCorrectionButton, setLoadingCorrectionButton] = useState(false)
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
    const [confirmLoading, setConfirmLoading] = useState(false)
    const [damagedProduct, setDamagedProduct] = useState({})
    const [damagedDialogText, setDamagedDialogText] = useState(false)
    const [completeDialogText, setCompleteDialogText] = useState(false)
    const [openDialogCorrection, setOpenDialogCorrection] = useState(false)
    const [openDialogComplete, setOpenDialogComplete] = useState(false)
    const [messageDuplicateProductId, setMessageDuplicateProductId] = useState(false)
    // Receipt documents live in a dialog during receiving (button next to Editar Lotes).
    const [showDocumentsDialog, setShowDocumentsDialog] = useState(false)
    const lotsDialogRef = useRef(null)
    const searchInputRef = useRef(null)
    const tableRef = useRef()
    const dispatch = useDispatch()

    // Quality check values.
    const [qualityCheckData, setQualityCheckData] = useState({
        productIsSegregated: false,
        productIsLabeled: false,
        clientAttendedAppointment: false
    })
    const [qualityCheckUpdateNotificationState, setQualityCheckUpdateNotificationState] = useState(false)
    const [qualityCheckDisabled, setQualityCheckDisabled] = useState(true)
    const [isReceiving, setIsReceiving] = useState(null)

    const { user } = useContext(UserContext);

    let { id } = useParams()
    let { warehouse_id } = useParams()
    const [params, setParams] = useState({warehouse_id: warehouse_id})
    const [activeLot, setActiveLot] = useState(null)
    const [animating, setAnimating] = useState(false)

    // Sticky supplier invoice (factura) for piece-count receiving — persists
    // across receives until the operator changes or clears it.
    const [invoiceNumber, setInvoiceNumber] = useState("")
    // Per-factura quantities edited in the correction dialog, seeded from the
    // corrected row's invoice_quantities. Empty array → legacy single-total path.
    const [invoiceCorrections, setInvoiceCorrections] = useState([])
    
    const [lastScannedProduct, setLastScannedProduct] = useState({id: 0})
    const lastScannedProductRef = useRef(null)
    const pageSize = useSelector((state) => state.pageSize.replenishmentProductsList);
    const [pageParams, setPageParams] = useState({
        page: 1,
        per_page: pageSize
    })

    const {
        isLoading,
        isError,
        error,
        data,
        refetch,
        isFetching,
        isPreviousData
    } = useQuery(['replenishment', id, pageParams], () => fetchReplenishmentPaginated(id, pageParams), {
        keepPreviousData: true,
        // Receiving is multi-window: poll while PROCESSING so pieces received in
        // one window show up in the others (same 4s cadence as the facturas/
        // documents section). Completed receipts don't change — stop polling.
        refetchInterval: (latest) => latest?.replenishment?.status === 'PROCESSING' ? 4000 : false,
    })

    // Per-replenishment opt-in (off by default): only receipts that require the
    // supplier factura block receiving without one. Capture-enabled warehouses
    // without the opt-in keep factura entry optional. Mirrors the backend 422
    // invoice_number_required.
    const supplierInvoiceRequired = data?.replenishment?.supplier_invoice_required === true
    // Capture availability comes from the receipt, not the warehouse: the platform
    // ORs the warehouse flag with the store's own opt-in, so a single merchant can
    // capture facturas at a warehouse that doesn't.
    const supplierInvoiceCaptureEnabled = data?.replenishment?.supplier_invoice_capture_enabled === true
    const facturaRequiredMissing = supplierInvoiceCaptureEnabled && supplierInvoiceRequired && invoiceNumber === ""
    // The operator's answer to "¿este recibo trae factura del proveedor?" at
    // start check-in — the WMS owns this yes/no; off by default.
    const [hasSupplierInvoice, setHasSupplierInvoice] = useState(false)

    // Same react-query key SupplierInvoiceFiles uses, so mounting both on this
    // page shares one cached fetch instead of two. Polls only in the statuses
    // whose views actually render the facturas/documents section.
    const { data: supplierInvoiceData } = useQuery(
        ["supplier-invoices", id],
        () => getSupplierInvoices(id),
        {
            enabled: supplierInvoiceCaptureEnabled && ['PROCESSING', 'COMPLETED', 'IN_PUTAWAY'].includes(data?.replenishment?.status),
            refetchInterval: 4000,
            refetchOnWindowFocus: true
        }
    )
    const supplierInvoiceNumbers = supplierInvoiceData?.invoices || []

    const hasQualityCheck = replenishment => replenishment.segregated_product != null && replenishment.labeled_product != null

    const locationsQuery = useQuery(['locations',params], () => fetchFreeLocationsForReplenishment(params), {
        enabled: data && data.replenishment && data.replenishment.location !== undefined
    })

    const animate = () => {
        //setAnimating(true)
        //setTimeout(() => setAnimating(false), 500)
    }

    useEffect(() => {
        // update default location ID when data is loaded
        if (locationsQuery.data && locationsQuery.data.length > 0) {
            setSelectLocationId(locationsQuery.data[0].id)
        }       
        // console.log('da', data)
    }, [locationsQuery])

    useEffect(() => {
        if (data?.warehouse_location_id !== null) {
            const focusTimer = setTimeout(() => {
                searchInputRef.current?.focus()
            }, 50)
            return () => clearTimeout(focusTimer)
          }
    }, [data])

    useEffect(() => {
        if (data) {
            setQualityCheckData({
                productIsSegregated: !!data.replenishment.segregated_product,
                productIsLabeled: !!data.replenishment.labeled_product,
                clientAttendedAppointment: !!data.replenishment.attended_appointment
            })
            setQualityCheckDisabled(false)
        }
    }, [data])

    useEffect(() => {
        if(lastScannedProductRef.current){
            lastScannedProductRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
            });
        }
    },[lastScannedProduct])

    const checkHasMoreStockThanExpected = (scannedProduct, productQuantity) => {
        const replenishmentProduct = data.replenishment.replenishment_products.find(({product_id}) => product_id === scannedProduct.id)
        const product = data.replenishment.products.find(({id}) => id === scannedProduct.id)

        if(!replenishmentProduct || !product){
            return true
        }

        if(parseInt(productQuantity) === 0){
            return false
        }

        const totalReceived = product.stock_by_lot.reduce((currentTotal, stockByLot) => currentTotal + parseInt(stockByLot.stock), 0)
        const newTotalReceived = totalReceived + parseInt(productQuantity)

        const hasMoreStockThanExpected = newTotalReceived > parseInt(replenishmentProduct.quantity) ? true : false
        return hasMoreStockThanExpected
    }

    const searchProductInReplenishmentLocally = (sku) => {
        const foundProduct = foundProducts.filter(product => product?.is_kit === false).find(product => product.bar_code == sku || product.product_codes.map(code => code.sku).includes(sku))
        if(foundProduct) return {product: foundProduct, exists: true}
        else return null
    }

    const handleSearchChange = async (val) => {
        if(isReceiving !== null){
            return false
        }
        //TODO BUG WHEN PRODUCT NOT FOUND & DOESNT EXIST
        setProductsNotFound(false)
        setproductSearchIsLoading(true)
        let search_res = null
        if (val !== ""){
            //If product is already in counting process, don't look for it again in the API
            search_res = searchProductInReplenishmentLocally(val)
            if(search_res === null) search_res = await searchProductInReplenishment(val, id)
            console.log("search_res")
            console.log(search_res)
            setproductSearchIsLoading(false)
            if (search_res === null) {
                //setFoundProduct(null)
                setExists(false)
                if (val === ""){
                    setProductsNotFound(false)
                }
                console.log("val", val)
                console.log(val)
                setProductsNotFound(true)
                setLastScannedProduct({id: 0})
                
            } else {
                
                if(lastScannedProduct.id != search_res.product.id) {
                    let scannedProductLots = foundLots.filter(lot => lot.product_id === search_res.product.id)
                    if(!scannedProductLots.map(lot => lot.id).includes(activeLot))
                        setActiveLot(null)
                }
                setLastScannedProduct(search_res.product)
                if (search_res.exists && search_res.exists === true) {
                    setExists(true)
                } else {
                    setExists(false)
                }
                if(foundProducts.findIndex(product => product.id == search_res.product.id) == -1){
                    if(!search_res.product.has_expiration && isInReplenishment(search_res.product)){
                        search_res.product.insertQuantity = 1
                        search_res.product.lot = null
                        setFoundProducts(existingItems => {return [search_res.product, ...existingItems]})
                    }else{
                        setFoundLots(existingItems => {
                            return existingItems.concat(search_res.lots)
                        })
                        const foundProductLots = search_res.lots.filter(lot => lot.product_id === search_res.product.id)
                        
                        foundProductLots.map(lot => {
                            const newProduct = { ...search_res.product}
                            newProduct.lot = lot
                            if(foundProductLots.length > 1){
                                newProduct.insertQuantity = 0
                            }else{
                                newProduct.insertQuantity = 1
                                setActiveLot(lot.id)
                                animate()
                            }
                            setFoundProducts(existingItems => {return [newProduct, ...existingItems]})
                        })
                    }
                    
                }else{
                    let availableLots = foundLots.filter(lot => lot.product_id === search_res.product.id)
                    let newActiveLot = activeLot
                    
                    if(availableLots.length == 1){
                        newActiveLot = availableLots[0].id
                        setActiveLot(newActiveLot)
                    }
                    let foundProductIndex = foundProducts.findIndex(product => product.id === search_res.product.id && newActiveLot == product.lot?.id)
                    if(foundProductIndex == -1){
                        alert(i18n.t('replenishments.show_replenishment.select_lot'))
                    }else{
                        setFoundProducts(existingItems => {
                            return existingItems.map((product, index) => {
                                return index != foundProductIndex ? product : {...product, insertQuantity: product.insertQuantity + 1}
                            })
                        })
                        animate()
                    }
                }
                setProductsNotFound(false)
                //setFoundProducts(existingItems => {return [...existingItems, newFoundProducts]})
                searchInputRef.current?.resetInput()
            }
            setproductSearchIsLoading(false)
        }
    }

    const handleUpdateReplenishmentStatus = async (status) => {
        setProductsNotFound(false)
        setLoadingCompleteButton(true)
        try {
            await updateReplenishmentStatus(id, status)
            await refetch()
            return true
        } catch (error) {
            const code = error.response?.data?.code
            if (code === "BILLING_CONFIG_MISSING") {
                window.alert(i18n.t('replenishments.show_replenishment.store_not_configured'))
            } else {
                // Covers REVERSE_LOGISTICS_REOPEN_NOT_ALLOWED, whose message is written for the
                // operator — the reopen button is already hidden for non-admins, so reaching this
                // means a stale page or a role change mid-session. `error` is a string on the paths
                // that render e.message and an object on those that render ExpectedError#to_h;
                // accept both so the alert never reads "[object Object]".
                const body = error.response?.data?.error
                window.alert(typeof body === 'string' ? body : (error.message || 'Error'))
            }
            return false
        } finally {
            setLoadingCompleteButton(false)
        }
    }

    const handleCompleteReplenishment = async (status) => {
        setProductsNotFound(false)

        const productsWithStockInReception = data.replenishment.products.filter(product => { return product.in_reception !== null }).length
        
        if (productsWithStockInReception > 0) {
            openCompleteDialog(productsWithStockInReception)     
        } else {
            const res = await completeReplenishment(id)
            refetch()
        }

    }

    const acceptCompleteReplenishment = async () => {
        setLoadingCompleteButton(true)
        const res = await completeReplenishment(id)
        refetch()
        setLoadingCompleteButton(false)
        setOpenDialogComplete(false)
    }

    const handleReceiveReplenishment = async status => {
        setLoadingButton(true)
        await receiveReplenishment(
            id,
            status,
            insertNumberOfBoxes
        )
        await refetch()
        setLoadingButton(false)
    }

    const handleUpdateQualityCheck = async ({
            clientAttendedAppointment,
            productIsSegregated,
            productIsLabeled
        }) => {
        setQualityCheckDisabled(true)

        const updatedQualityData = {
            ...qualityCheckData,
            ...(clientAttendedAppointment != null && { clientAttendedAppointment }),
            ...(productIsSegregated != null && { productIsSegregated }),
            ...(productIsLabeled != null && { productIsLabeled })
        }

        setQualityCheckData(updatedQualityData)

        await updateQualityCheck(
            id,
            updatedQualityData
        )

        setQualityCheckDisabled(false)
        setQualityCheckUpdateNotificationState(true)
    }

    const handleReceiveProducts = async (product) => {
        // A factura is required before receiving when the warehouse captures
        // supplier invoices — mirrors the backend 422 (invoice_number_required)
        // and the box-scan flow, so the piece-count path can't slip a receive
        // through without one. The caller already set isReceiving; clear it so
        // the row's "Recibir" button doesn't stay stuck loading after we block.
        if (facturaRequiredMissing) {
            setIsReceiving(null)
            return
        }
        console.log("Receiving product...")
        const res = await receiveProduct(product, product.insertQuantity, data.replenishment.warehouse_location_id, id, user.id, invoiceNumber)
        console.log("Ended Receiving product...")
        refetch()
        removeProductFromFounds(product)
        //setExists(false)
        searchInputRef.current?.resetInput()
        setproductSearchIsLoading(false)
        // setTextToSearch("")
        //setInsertQuantity(1)
        setProductsNotFound(false)
        setIsReceiving(null)
    }

    // TODO Merge handleUpdateReplenishmentStatus and this into a single method.
    const handleProcessReplenishment = async () => {
        setLoadingButton(true)
        try {
            await updateReplenishmentStatus(id, "PROCESSING", supplierInvoiceCaptureEnabled ? { supplier_invoice_required: hasSupplierInvoice } : {})
        } catch (error) {
            if (error.response?.data?.code === "BILLING_CONFIG_MISSING") {
                window.alert(i18n.t('replenishments.show_replenishment.store_not_configured'))
            }
            else {
                // Same string/object guard as handleUpdateReplenishmentStatus, so this never
                // shows a raw "Error: Request failed with status code 422" axios string.
                const body = error.response?.data?.error
                window.alert(typeof body === 'string' ? body : (error.message || 'Error'))
            }
        }
        await refetch()
        setLoadingButton(false)
    }

    const handlAddProductToReplenishment = async (product) => {
        try {
            setproductSearchIsLoading(true)
            const res = await addProductToReplenishment(product, id)
            setProductsNotFound(false)
            setLastScannedProduct({id: 0})
            setExists(true)
            await refetch()
            setproductSearchIsLoading(false)
            if(product.has_expiration){
                setLastScannedProduct(product)
            }else{
                product.insertQuantity = 1
                product.lot = null
                setFoundProducts(existingItems => {return [product, ...existingItems]})
            }   
            } catch (error) {
            if (error.response?.data?.errorType === "RecordInvalid") {
                setMessageDuplicateProductId(true)
                return
            }
        }
    }

    const openCorrectReception  = async (product) => {
        // const res = await addProductToReplenishment(product, id)
        // refetch()
        // searchInputRef.current?.resetInput()
        // setProductsNotFound(false)
        // Seed from the row's per-lot count (what the input below displays), not the
        // product-level total, so an untouched submit posts this lot's quantity.
        setCorrectQuantity(product.lot_reception ?? 0)
        // Seed the per-factura editor from the row's breakdown (a copy, so edits
        // don't mutate the query cache); empty when the row has no facturas.
        setInvoiceCorrections(
            supplierInvoiceCaptureEnabled && product.invoice_quantities?.length
                ? product.invoice_quantities.map(({ invoice_number, quantity }) => ({ invoice_number, quantity, maxQuantity: quantity }))
                : []
        )
        setCorrectedProduct(product)
        setOpenDialogCorrection(true)
    }

    const removeProductFromFounds = (product) => {
        console.log("Removing product", product)
        setFoundProducts(existingItems => {
            const receivedIndex = existingItems.findIndex(foundProduct => foundProduct == product)
            if(!product.has_expiration) return [...existingItems.slice(0, receivedIndex), ...existingItems.slice(receivedIndex+ 1)]
            else return existingItems.map((product, index) => {
                return index === receivedIndex ? {...product, insertQuantity: 0} : product
            })
        })
    }

    const handleCorrectReception= async (product) => {
        try{
            setLoadingCorrectionButton(true)
            const { newQuantity, corrections } = buildCorrectionPayload(invoiceCorrections, correctQuantity)
            const res = await correctProduct(product, newQuantity, id, product.lot_id, corrections)
            refetch()
            setOpenDialogCorrection(false)
        } catch (error) {
            if (error.response?.data?.errorType === "RecordInvalid") {
                setMessageDuplicateProductId(true)
                return
            }
            // Surface every other failure (e.g. the backend's 422 when the receipt is
            // not in a reception status) instead of swallowing it.
            const body = error.response?.data?.error
            window.alert(typeof body === 'string' ? body : (error.message || 'Error'))
        } finally {
            // Always release the button; without this a failed correction leaves it
            // stuck loading and bricks the dialog for the rest of the session.
            setLoadingCorrectionButton(false)
        }
    }

    const openDamagedDialog = async (product) => {
        setDamagedDialogText("Mueve "+product.insertQuantity+" piezas a la localización: D-1-1-1 y clicka continuar")
        setDamagedProduct(product)
        setOpenConfirmDialog(true)
        setConfirmLoading(false)
    }


    const openCompleteDialog = async (productsWithStockInReception) => {
        setCompleteDialogText("Tienes "+productsWithStockInReception+" productos con piezas en recibo, ¿aceptas completar el recibo y que esas piezas se eliminen?")
        setOpenDialogComplete(true)
    }


    const handleDamageProducts = async () => {
        const product = damagedProduct
        setConfirmLoading(true)
        console.log("prid")
        console.log(product)
        const res = await updateDamagedProduct(product, product.insertQuantity, id, product.has_expiration ? product.lot.id : null, invoiceNumber)
        await refetch()
        setConfirmLoading(false)
        setOpenConfirmDialog(false)
        //setFoundProducts([])
        setProductsNotFound(false)
        //setExists(false)
        //setTextToSearch("")
        //setInsertQuantity(1)

        removeProductFromFounds(product)
        setDamagedProduct({})
        setIsReceiving(null)
    }

    const resetSearch = async () => {
        setProductsNotFound(false)
        setTextToSearch("")
    }

    const getLot = (product) => {
        if(product.lot_id){
            const lot = product.lots.find(lot => lot.id === product.lot_id)
            if(lot){
                return <>{lot.unique_code}<br/>{<i>{lot?.expiration_date_moment?.format('DD/MM/Y')}</i>}</>
            }
        }
        // Returns receipts don't declare lots on product.lots, so fall back to the code the
        // received-lots row carried (sourced from the received stock units). Kept outside the
        // lot_id guard so a lot without an id still renders its code.
        if(product.lot_code){
            return <>{product.lot_code}{product.lot_expiration ? <><br/><i>{moment(product.lot_expiration, "YYYY-MM-DD").format('DD/MM/Y')}</i></> : null}</>
        }
        return product.has_expiration ? 'No tiene lote' : 'No requiere lote'
    }

    const getInReception = (product) => product.lot_reception

    const getProcessed = (product) => product.lot_stock

    function getName(product) {
        let name = ""
        if (product.parent && product.parent.name) {
            name = name + product.parent.name + " - "
        }
        name = name + product.name

        return (
        <div>
            {product.is_scannable === false &&
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full font-medium bg-yellow-100 text-yellow-800 mx-1`}>
                    {i18n.t('general.product.insert')}
                </span>
            }
            {name}
        </div>
        )
    }

    const searchStock = (product_id) => {
        // console.log('da', data)
        let product = data.replenishment.products.find(function(product, index) {
            if(product.id === product_id)
                return true;
        });
        // console.log(product)
        if (product) {
            return product.stock_for_replenishment
        } else {
            return 0
        }
        
    }


    const product_table_columns = [
        {
            Header: 'Lote',
            accessor: 'lot'
        },
        {
            Header: 'Nombre',
            accessor: 'name'
        },
        {
            Header: <div className="flex justify-center">SKU</div>,
            accessor: 'sku'
        },
        {
            Header: <div className="flex justify-center">UPC</div>,
            accessor: 'upc'
        },
        {
            Header: <div className="flex justify-center">Contadas</div>,
            accessor: 'quantity',
            Cell: InputQuantity,
        },
        {
            Header: <div className="flex justify-center">Acciones</div>,
            accessor: 'actions'
        }
    ]

    const exptected_products_table_columns = [
        {
            Header: 'Lote',
            accessor: 'lot',
            // The lot filter is server-side and joins through DECLARED lots, which
            // reverse-logistics receipts don't have — so it would return zero rows for
            // the received lot codes this column now shows. Disable it there.
            disableFilters: !!data?.replenishment?.is_from_return,
            disableSortBy: false,
        },
        {
            Header: 'Nombre',
            accessor: 'name',
            disableFilters: false,
            disableSortBy: true,
        },
        {
            Header: 'SKU',
            accessor: 'sku',
            disableFilters: false,
            disableSortBy: true,
        },
        {
            Header: 'UPC',
            accessor: 'upc',
            disableFilters: false,
            disableSortBy: true,
        },
        ...(supplierInvoiceCaptureEnabled ? [{
            // Sits with the other left-aligned filter columns; filter sends the
            // `invoice_number` query param to replenishments_paginated.
            Header: i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.column_header'),
            accessor: 'invoice_number',
            disableFilters: false,
            disableSortBy: true,
        }] : []),
        {
            Header: <div className="flex justify-center">Esperadas</div>,
            accessor: 'quantity',
            disableFilters: true,
            disableSortBy: true,
        },
        {
            Header: <div className="flex justify-center">Procesadas</div>,
            accessor: 'processed_quantity',
            disableFilters: true,
            disableSortBy: true,
        },
        {
            Header: <div className="flex justify-center">En recepción</div>,
            accessor: 'in_reception',
            disableFilters: true,
            disableSortBy: true,
        }
    ]

    const [showCreateLotsDialog, setShowCreateLotsDialog] = useState(false)

    const hasExpirations = () => getExpirableProducts().length > 0

    const hasWarehouseLocation = () => data.replenishment.warehouse_location_id !== null

    const getExpirableProducts = () => data.replenishment.products.filter(product => product.has_expiration)

    const isMissingAllLots = () => {
        return false
        //if(!hasExpirations()) return false;
        //return data.replenishment.lots.length == 0
    }

    const isInReplenishment = (product) => {
        return data.replenishment.replenishment_products.findIndex(rp => rp.product_id == product.id) > -1
    }

    const hasMissingLots = () => {
        if(!hasExpirations() || !lastScannedProduct.has_expiration) return false;
        if(!isInReplenishment(lastScannedProduct)) return false;
        return foundLots.filter(lot => lot.product_id == lastScannedProduct.id).length == 0
    }

    const processedLots = (product) => {
        let processedLots = foundLots
        processedLots.forEach(lot => {
            lot.expiration_date_moment = lot.expiration_date == '' ? '' : moment(lot.expiration_date, "YYYY-MM-DD")
            const product = data.replenishment.replenishment_products.find(rp => rp.product_id == lot.product_id)
            if (product)  lot.replenishment_product_id = product.id
        });
        return processedLots.filter(lot => lot.product_id == product.id)
    }

    const onLotsSaved = (lots) => {
        const oldLotIds = foundLots.map(lot => lot.id)
        const newFoundLots = lots.filter(lot => !oldLotIds.includes(lot.id) )
        const newLotIds = lots.map(lot => lot.id)
        const missingLotsIds = foundLots.filter(lot => lot.product_id == lastScannedProduct.id).filter(lot => !newLotIds.includes(lot.id)).map(lot => lot.id)
        
        newFoundLots.map(lot => {
            setFoundProducts(existingItems => {
                return [...existingItems, {...lastScannedProduct,
                    insertQuantity: 0,
                    lot: {...lot, expiration_date_moment: lot.expiration_date == '' ? '' : moment(lot.expiration_date, "YYYY-MM-DD")}
                }].sort((a, b) => a.name > b.name ? 1 : -1)
            })
            
        })
        setFoundLots(existingItems => {
            return [...existingItems.filter(lot => lot.product_id != lastScannedProduct.id).concat(lots)]
        })
        setFoundProducts(existingItems => {
            return existingItems.filter(product => !missingLotsIds.includes(product.lot.id))
        })
        refetch()
        setShowCreateLotsDialog(false)
        //handleSearchChange(lastScannedProduct.bar_code)
    }

    const onFilterChange = (activeFilters) => {
        exptected_products_table_columns.forEach((col) => {
            if (pageParams[col.accessor]) {
            delete pageParams[col.accessor]
            }
        })
        let filters = []
        activeFilters.forEach((filter) => {
            filters[filter.id] = filter.value
        })
        setPageParams({ ...pageParams, ...filters, page: 1 })
    }

    const handleSaveLots = () => lotsDialogRef.current?.handleSaveLots()

    const hasScannableProductsMoreStockThanExpected = foundProducts.some(foundProduct => {
        const hasMoreStockThanExpected = checkHasMoreStockThanExpected(foundProduct, foundProduct.insertQuantity)
        return foundProduct.is_scannable && hasMoreStockThanExpected ? true : false
    })

    return (<>
        <Notification
            show={qualityCheckUpdateNotificationState}
            setShow={setQualityCheckUpdateNotificationState}
            type="success"
            title={i18n.t('replenishments.show_replenishment.notifications.quality_check_saved')}
        />
        <Notification
            show={messageDuplicateProductId}
            setShow={setMessageDuplicateProductId}
            type="error"
            title={i18n.t('replenishments.show_replenishment.notifications.duplicate_product_added')}
        />
        <PageView 
        topMenu={
            <FilterMenu>
                {isLoading ?
                " "
                :

                <div>
                    <h1 className="text-lg leading-4 font-medium text-gray-900"> {i18n.t('replenishments.show_replenishment.title') + " " + data.replenishment.id +" - "+data.replenishment.store}</h1>
                    <h3 className="text-sm leading-3 font-normal text-gray-500">{data.replenishment.sell_ahead ? i18n.t('replenishments.show_replenishment.sell_ahead') : i18n.t('replenishments.show_replenishment.not_sell_ahead')}</h3>
                </div>
                
                }

                {data && data.replenishment && (data.replenishment.status === 'COMPLETED' || data.replenishment.status === 'IN_PUTAWAY') ?
                    <>
                        {/* Reopening a returns receipt is what created the over-reception this screen
                            now prevents by showing the lot, so the backend restricts it to warehouse
                            admins (REPLENISHMENTS_COMPLETE -> permissions.complete_replenishment, the
                            same grant the Completar button below reads). Hide the button rather than
                            disable it: for an operator the action is simply not available, and the
                            lot is already visible without reopening. Supplier receipts are unaffected. */}
                        {data.replenishment.status !== 'COMPLETED' && (!data.replenishment.is_from_return || user.permissions.complete_replenishment) ? <ButtonLoader className="mr-5" type="secondary" loading={loadingCompleteButton} onClick={() => handleUpdateReplenishmentStatus("PROCESSING")} disabled={loadingCompleteButton}>{i18n.t('replenishments.show_replenishment.open_receipt')}</ButtonLoader> : <></>}
                        {!data.replenishment.is_from_return && data.replenishment.status !== 'COMPLETED' ? <ButtonLoader loading={loadingCompleteButton} onClick={() => handleCompleteReplenishment()} disabled={!user.permissions.complete_replenishment}>{i18n.t('replenishments.show_replenishment.complete_receipt')}</ButtonLoader> : <></> }
                    </>
                :
                data && data.replenishment && data.replenishment.status === 'PROCESSING' ?
                    <>
                        {!hasMissingLots() && hasExpirations() && <Tooltip title={i18n.t('replenishments.show_replenishment.modify_lots')}>
                            <ButtonLoader type="secondary" loading={loadingButton} onClick={() => setShowCreateLotsDialog(true)} disabled={loadingButton || !lastScannedProduct?.has_expiration}>{i18n.t('replenishments.show_replenishment.edit_lots')}</ButtonLoader>
                        </Tooltip>}
                        {supplierInvoiceCaptureEnabled && (
                            <Button type="secondary" className="ml-5" onClick={() => setShowDocumentsDialog(true)}>
                                {i18n.t('replenishments.show_replenishment_boxes.supplier_invoice_files.documents_button')}
                            </Button>
                        )}
                        {!hasMissingLots() && <ButtonLoader className="ml-5" loading={loadingCompleteButton} onClick={() => handleUpdateReplenishmentStatus("IN_PUTAWAY")} disabled={loadingCompleteButton || (!data.replenishment.can_receive_more_stock_than_expected && hasScannableProductsMoreStockThanExpected)}>{i18n.t('replenishments.show_replenishment.finish_check_in')}</ButtonLoader>}
                        {hasMissingLots() && <ButtonLoader loading={loadingCompleteButton} onClick={() => handleSaveLots()} disabled={loadingCompleteButton}>{i18n.t('replenishments.show_replenishment.continue')}</ButtonLoader>}
                    </>
                :
                    <></>
                }
                </FilterMenu>
        }
        >

            <InboundAppointmentSection replenishmentId={id} warehouseId={warehouse_id} />
            <DialogView setOpen={setOpenDialogCorrection} open={openDialogCorrection} >

            {correctedProduct !== null && correctedProduct.lot_reception > 0 ? 
            
                (
                    <>
                        <h1 className="text-lg leading-6 font-medium text-gray-900">{i18n.t('replenishments.show_replenishment.receipt_correction')}</h1>
                        <div>
                        <label className="block text-sm mb-2 font-medium text-gray-700">{i18n.t('replenishments.show_replenishment.name')}:</label> {correctedProduct.name} <br></br>
                        <label className="block text-sm mt-2 font-medium text-gray-700">{i18n.t('replenishments.show_replenishment.skus')}:</label> {getSkus(correctedProduct.product_codes)} <br></br>
                        <label className="block text-sm mt-2 font-medium text-gray-700">{i18n.t('replenishments.show_replenishment.upc')}:</label> {correctedProduct.bar_code}
                        </div>

                        {invoiceCorrections.length > 0 ? (
                        <div className="mb-5">
                            <label className="block text-sm mt-2 font-medium text-gray-700">{i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.correction_per_invoice')}:</label>
                            <div className="mt-2 flex flex-col gap-2">
                                {invoiceCorrections.map((row, index) => {
                                    const hasInvoice = Boolean(row.invoice_number)
                                    return (
                                        <div key={`${row.invoice_number ?? "__none__"}-${index}`} className="flex items-center gap-3">
                                            <span
                                                title={hasInvoice ? row.invoice_number : i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.chip_empty')}
                                                className={`inline-flex items-center justify-center w-28 flex-shrink-0 rounded-full border px-2.5 py-0.5 text-xs font-mono font-semibold ${hasInvoice ? "bg-emerald-50 border-emerald-200 text-emerald-800" : "bg-amber-50 border-amber-300 text-amber-800"}`}
                                            >
                                                <span className="truncate">{hasInvoice ? row.invoice_number : i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.chip_empty')}</span>
                                            </span>
                                            <input
                                                type="number"
                                                min="0"
                                                max={row.maxQuantity}
                                                value={row.quantity}
                                                onChange={(event) => {
                                                    // Keep the raw string while typing: eager clamping turns a
                                                    // cleared field into 0 (zeroing the bucket if saved) and
                                                    // fights multi-digit entry. Clamped on blur and on save.
                                                    const next = event.target.value
                                                    setInvoiceCorrections((current) => current.map((r, i) => i === index ? { ...r, quantity: next } : r))
                                                }}
                                                onBlur={() => {
                                                    setInvoiceCorrections((current) => current.map((r, i) => i === index ? { ...r, quantity: clampInvoiceCorrectionQuantity(r) } : r))
                                                }}
                                                className="w-20 border border-gray-300 rounded-md p-1 text-base focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                                            />
                                        </div>
                                    )
                                })}
                            </div>
                            <div className="mt-2 text-sm font-medium text-gray-700">
                                {i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.correction_total')}: {invoiceCorrectionsTotal(invoiceCorrections)}
                            </div>
                        </div>
                        ) : (
                        <div className="mb-5">
                        <label className="block text-sm mt-2 font-medium text-gray-700">{i18n.t('replenishments.show_replenishment.new_quantity')}:</label>
                            <InputQuantity onlyMinus={true} initialValue={correctedProduct.lot_reception} updateData={(value) => {setCorrectQuantity(value)}}></InputQuantity>
                        </div>
                        )}

                        <div>
                        
                        
                        <button
                            type="button"
                            className="bg-white mr-2 py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                            onClick={() => setOpenDialogCorrection(false)}
                        >
                            {i18n.t('replenishments.show_replenishment.cancel')}
                        </button>
                            <ButtonLoader loading={loadingCorrectionButton} onClick={() => handleCorrectReception(correctedProduct)} disabled={loadingCorrectionButton}>{i18n.t('replenishments.show_replenishment.correct')}</ButtonLoader>
                        </div>
                    </>
                )
                
                :

                (
                    <>
                        <div>
                            <h1 className="text-lg leading-6 font-medium text-gray-900">{i18n.t('replenishments.show_replenishment.no_pieces_in_receipt')}</h1>
                            <button
                                type="button"
                                className="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                onClick={() => setOpenDialogCorrection(false)}
                           >
                                {i18n.t('replenishments.show_replenishment.cancel')}
                            </button>
                        </div>
                    </>
                )
            }
                

                
            </DialogView>

            {/* Receipt documents: during receiving they live behind the Documentos
                button (header) instead of inline, keeping the counting view lean. */}
            <DialogView setOpen={setShowDocumentsDialog} open={showDocumentsDialog} closeOnBackdrop className=" w-full">
                <div className="relative">
                    <button
                        type="button"
                        onClick={() => setShowDocumentsDialog(false)}
                        aria-label={i18n.t('replenishments.show_replenishment.cancel')}
                        className="absolute top-0 right-0 min-h-touch px-3 inline-flex items-center justify-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-300 rounded"
                    >
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                    <SupplierInvoiceFiles replenishmentId={id} />
                </div>
            </DialogView>

            <DialogView setOpen={setOpenDialogComplete} open={openDialogComplete} >
                <div className="p-5">

                
                <h1 className="text-lg leading-6 font-medium text-gray-900">{i18n.t('replenishments.show_replenishment.attention')}</h1>

                <p className="text-gray-500 text-base">{completeDialogText}</p>

                <div>
                <button
                    type="button"
                    className="mr-5 bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    onClick={() => setOpenDialogComplete(false)}
                >
                    Cancelar
                </button>
                <ButtonLoader loading={loadingCompleteButton} onClick={() => acceptCompleteReplenishment()} disabled={loadingCompleteButton}>{i18n.t('replenishments.show_replenishment.accept')}</ButtonLoader>
                </div>
                </div>
            </DialogView>


            {isLoading && foundProducts.length == 0 ? (
                <div key="loading">Loading...</div>
            ) : isError ? (
                <div key="error">Error: {error.message}</div>
            ) : (
            <div key="content" className="flex-1 flex flex-col gap-6 overflow-auto">
                {!isMissingAllLots() || !hasWarehouseLocation() ?
                <>
                    <main className="w-full bg-white rounded-lg shadow-sm">
                        <section
                        aria-labelledby="primary-heading"
                        className="min-w-0 w-full flex flex-col"
                        >
                        
                        <div className="mx-5 my-5">
                        
                            {
                                data.replenishment && data.replenishment.status === 'COMPLETED' ? (
                                    <>
                                        <h1 className="font-bold text-lg leading-6 text-gray-900 flex items-center gap-2 mb-4">
                                            <ClipboardCheckIcon className="h-5 w-5 text-emerald-600 flex-shrink-0" aria-hidden="true" />
                                            {i18n.t('replenishments.show_replenishment.receipt_completed')}
                                        </h1>
                                        { !data.replenishment.is_from_return && (
                                            <>
                                                <label className="block text-base font-medium text-gray-700" id="headlessui-listbox-label-3">Quality check</label>
                                                <div className="mt-1">
                                                    <Checkbox
                                                        label={i18n.t('replenishments.show_replenishment.segregated_check')}
                                                        onChange={(isChecked) =>
                                                            handleUpdateQualityCheck({ productIsSegregated: isChecked })
                                                        }
                                                        checked={qualityCheckData.productIsSegregated}
                                                        disabled={qualityCheckDisabled}
                                                    />
                                                    <Checkbox
                                                        label={i18n.t('replenishments.show_replenishment.labeled_check')}
                                                        onChange={(isChecked) =>
                                                            handleUpdateQualityCheck({ productIsLabeled: isChecked })
                                                        }
                                                        checked={qualityCheckData.productIsLabeled}
                                                        disabled={qualityCheckDisabled}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </>
                                ) :
                                data && data.replenishment && data.replenishment.status === 'IN_PUTAWAY' ? (
                                    <>
                                        <h1 className="font-bold text-lg leading-6 text-gray-900 flex items-center gap-2 mb-4">
                                            <ClipboardCheckIcon className="h-5 w-5 text-emerald-600 flex-shrink-0" aria-hidden="true" />
                                            {i18n.t('replenishments.show_replenishment.receipt_stage_complete')}
                                        </h1>
                                        { !data.replenishment.is_from_return && (
                                            <>
                                                <label className="block text-base font-medium text-gray-700" id="headlessui-listbox-label-3">Quality check</label>
                                                <div className="mt-1">
                                                    <Checkbox
                                                        label={i18n.t('replenishments.show_replenishment.segregated_check')}
                                                        onChange={(isChecked) =>
                                                            handleUpdateQualityCheck({ productIsSegregated: isChecked })
                                                        }
                                                        checked={!!qualityCheckData.productIsSegregated}
                                                        disabled={qualityCheckDisabled}
                                                    />
                                                    <Checkbox
                                                        label={i18n.t('replenishments.show_replenishment.labeled_check')}
                                                        onChange={(isChecked) =>
                                                            handleUpdateQualityCheck({ productIsLabeled: isChecked })
                                                        }
                                                        checked={!!qualityCheckData.productIsLabeled}
                                                        disabled={qualityCheckDisabled}
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </>
                                ) :
                                data.replenishment && data.replenishment.status === 'REQUESTED' || data.replenishment.status === 'WITHOUT_SCHEDULING' ? (
                                    <>
                                        <h1 className="text-lg mt-5 mb-5 leading-6 font-medium text-gray-900">{i18n.t('replenishments.show_replenishment.inventory_receipt')}</h1>

                                        <label className="block text-base font-medium text-gray-700" id="headlessui-listbox-label-3">{i18n.t('replenishments.show_replenishment.how_many_boxes_in_receipt')}</label>
                                        <div className="w-24 my-5">
                                            <InputQuantity initialValue={insertNumberOfBoxes} updateData={(value) => {setInsertNumberOfBoxes(value)}}></InputQuantity>
                                        </div>

                                        <label className="block text-base font-medium text-gray-700" id="headlessui-listbox-label-3">{i18n.t('replenishments.show_replenishment.attended_appointment')}</label>
                                        <div className="mt-1">
                                            <Checkbox
                                                label={i18n.t('replenishments.show_replenishment.attended_appointment')}
                                                onChange={(isChecked) =>
                                                    handleUpdateQualityCheck({ clientAttendedAppointment: isChecked })
                                                }
                                                checked={qualityCheckData.clientAttendedAppointment}
                                                disabled={qualityCheckDisabled}
                                            />
                                        </div>

                                        <ButtonLoader className="mt-5 mr-1" loading={loadingButton} onClick={() => handleReceiveReplenishment()} disabled={loadingButton}>
                                            {i18n.t('replenishments.show_replenishment.mark_as_received')}
                                        </ButtonLoader>
                                    </>
                                ) :
                                hasWarehouseLocation() ?
                                    (<>
                                        <div className="flex items-stretch">
                                            <div className="flex-grow">
                                                <div className="flex justify-between items-start">
                                                    <div className="mt-3 grid grid-cols-4 flex-grow">
                                                        <div className="mx-2 col-span-3">
                                                            <label className="block text-base font-medium text-gray-700" id="headlessui-listbox-label-3">Cuenta piezas por SKU o UPC</label>
                                                            <SearchInput debounce="10" dependencies={[foundProducts, activeLot, foundLots, isReceiving, invoiceNumber]} inputValue={textToSearch} className="w-80 my-2" onChange={handleSearchChange} onReset={() => {resetSearch()}} ref={searchInputRef}/>
                                                        </div>
                                                    </div>
                                                    {/* Only factura-required receipts show the chip — on the rest it
                                                        reads like an obligation that no longer exists. */}
                                                    {supplierInvoiceCaptureEnabled && supplierInvoiceRequired && (
                                                        <div className="mt-3 mr-2 flex-shrink-0 text-right">
                                                            {/* "Factura en proceso" only describes an active factura — with none
                                                                set yet the chip alone ("Agregar Factura") says it all. */}
                                                            {invoiceNumber && (
                                                                <div className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-1">
                                                                    {i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.active_label')}
                                                                </div>
                                                            )}
                                                            <SupplierInvoiceChip
                                                                invoiceNumber={invoiceNumber}
                                                                onChange={setInvoiceNumber}
                                                                onDialogClose={() => searchInputRef.current?.focus()}
                                                                valueOnly
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <CreateLotsDialog open={hasMissingLots() ||  showCreateLotsDialog} onSuccess={(lots) => onLotsSaved(lots)}
                                            onCancel={()=>setShowCreateLotsDialog(false)} lots={processedLots(lastScannedProduct)} products={[lastScannedProduct]}
                                            replenishment_products={data.replenishment.replenishment_products} replenishment_id={data.replenishment.id}
                                        ></CreateLotsDialog>
                                    </>)
                                    :
                                    <>
                                        <h1 className="text-lg mt-5 mb-5 leading-6 font-medium text-gray-900">Empezar check-in</h1>
                                        {supplierInvoiceCaptureEnabled && (
                                            <div className="mb-4">
                                                <Checkbox
                                                    label={i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.has_invoice_question')}
                                                    onChange={isChecked => setHasSupplierInvoice(isChecked)}
                                                    checked={hasSupplierInvoice}
                                                    disabled={loadingButton}
                                                />
                                                <p className="text-sm text-gray-500 mt-1">{i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.has_invoice_help')}</p>
                                            </div>
                                        )}
                                        <ButtonLoader className="my-1" loading={loadingButton} onClick={() => handleProcessReplenishment()} disabled={loadingButton}>Empezar</ButtonLoader>
                                    </>
                            }
                            </div>
                        <div>
                        {
                            productSearchIsLoading ?<div className="ml-10 block text-sm font-medium text-gray-700" >Buscando...</div> : ""
                        }
                        {
                            messageProductsNotFound ?<div className="ml-10 block text-sm font-medium text-gray-700" >El SKU buscado no existe</div> : ""
                        }
                        {foundProducts.length > 0 && exists === true || messageProductsNotFound

                            ? 
                        <>
                            {!data.replenishment.can_receive_more_stock_than_expected && hasScannableProductsMoreStockThanExpected && (
                                <div className="bg-red-500 text-white py-2 px-6 flex gap-2">
                                    <ExclamationCircleIcon className="h-7 w-7"/>
                                    <span>
                                        {i18n.t('replenishment.error_unexpected_stock_start')}
                                        <span className="font-bold">{i18n.t('replenishment.error_unexpected_stock_middle')}</span>
                                        {i18n.t('replenishment.error_unexpected_stock_end')}
                                    </span>
                                </div>
                            )}

                            <table className="min-w-full divide-y divide-gray-200 overflow-y-auto border-collapse">
                            <thead className="bg-gray-50">
                                    <tr>
                                    {product_table_columns.map((column)=>(
                                    <th
                                        key={column.accessor}
                                        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                                    >
                                        {column['Header']}
                                    </th>
                                ))}
                                            
                                    </tr>
                            </thead>
                            <tbody>

                            { foundProducts.map(foundProduct => {
                                const isLastScannedProduct = foundProduct.id === lastScannedProduct.id
                                const hasMoreStockThanExpected = checkHasMoreStockThanExpected(foundProduct, foundProduct.insertQuantity)
                                const disableReceiveStock = foundProduct.is_scannable && hasMoreStockThanExpected && !data.replenishment.can_receive_more_stock_than_expected ? true : false
                                let rowClassName = isLastScannedProduct ? "border-2 border-blue-400 animate-pulse " : ""

                                const replenishmentProduct = data.replenishment.replenishment_products.find(({product_id}) => product_id === foundProduct.id)
                                const product = data.replenishment.products.find(({id}) => id === foundProduct.id)
                                if(!product) return null
                                const totalReceived = product.stock_by_lot.reduce((currentTotal, stockByLot) => currentTotal + parseInt(stockByLot.stock), 0)

                                const expectedRemainingStock = replenishmentProduct ? (replenishmentProduct.quantity - totalReceived) : 0

                                if(animating && foundProduct.lot?.id == activeLot){
                                    rowClassName += 'bg-gray-100 animate-pulse'
                                } else if (disableReceiveStock){
                                    rowClassName += 'bg-red-50'
                                } else{
                                    rowClassName += 'bg-gray-50'
                                }

                                // Remove the focused effect after some time
                                if(isLastScannedProduct){
                                    setTimeout(() => {
                                        lastScannedProductRef.current?.classList.remove("animate-pulse")
                                    }, 1000)
                                }

                                return <tr key={`${foundProduct.id}${foundProduct.lot?.id}`} className={rowClassName} ref={isLastScannedProduct ? lastScannedProductRef : null}>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 text-right">
                                        <label>
                                        {!foundProduct.has_expiration && "No requiere lote"}
                                        {foundLots.filter(lot => lot.product_id === foundProduct.id).length > 1 && foundProduct.lot && (<>
                                            <input
                                                type="radio"
                                                className="form-radio mr-1"
                                                value={foundProduct.lot.id}
                                                checked={activeLot == foundProduct.lot.id}
                                                onChange={(e) => {
                                                    setActiveLot(parseInt(e.target.value))
                                                    searchInputRef.current?.focus()
                                                }}
                                            /> 
                                        </> )} 
                                        {foundProduct.lot?.unique_code}<br/>
                                        <i>{foundProduct.lot?.expiration_date_moment.format('DD/MM/Y')}</i>

                                        </label>
                                    </td>
                                    <td className="px-2 py-2 max-w-xs text-sm text-gray-500 text-center">
                                    {getName(foundProduct)}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 text-center">
                                    {getSkus(foundProduct.product_codes)}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 text-center">
                                    {foundProduct.bar_code}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 text-center">
                                        {/* <InputQuantity initialValue={insertQuantity} updateData={(value) => {setInsertQuantity(value)}}></InputQuantity> */}
                                        <div className={`max-w-max ${disableReceiveStock ? "border-red-500 border-2" : ""}`}>
                                        <InputNumber
                                            min={0}
                                            // size="large"
                                            value={foundProduct.insertQuantity}
                                            onChange={(value) =>{
                                                setFoundProducts(existingItems => {
                                                    let updatedProductIndex = existingItems.findIndex(updatedProduct => updatedProduct == foundProduct)
                                                    return existingItems.map((product, index) => {
                                                        return index != updatedProductIndex ? product : {...product, insertQuantity: value}
                                                    })
                                                })
                                                setActiveLot(null)
                                                setLastScannedProduct(foundProduct)
                                                //setInsertQuantity(value)
                                            }}
                                            keyboard={true}
                                        />
                                        </div>

                                        {disableReceiveStock && (
                                            <div className="text-red-400">
                                                {`${expectedRemainingStock} ${i18n.t('replenishment.expected_quantity')}`}
                                            </div>
                                        )}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-gray-500 text-center">
                                        <Tooltip title={facturaRequiredMissing ? i18n.t('replenishments.show_replenishment_boxes.supplier_invoice.receive_requires_invoice') : ''}>
                                            {/* span wrapper + pointer-events:none — an antd tooltip won't fire over a natively-disabled button */}
                                            <span className={`inline-flex mr-2 ${facturaRequiredMissing ? 'cursor-not-allowed' : ''}`}>
                                                <ButtonLoader
                                                    type="primary"
                                                    loading={isReceiving == foundProduct.bar_code}
                                                    disabled={foundProduct.insertQuantity < 1 || isReceiving !== null || disableReceiveStock || facturaRequiredMissing}
                                                    style={facturaRequiredMissing ? { pointerEvents: 'none' } : undefined}
                                                    onClick={() => {
                                                        setIsReceiving(foundProduct.bar_code)
                                                        handleReceiveProducts(foundProduct)
                                                    }}
                                                >
                                                    Recibir
                                                </ButtonLoader>
                                            </span>
                                        </Tooltip>

                                        <Button
                                            type="secondary"
                                            className=""
                                            loading={isReceiving == ('-'+foundProduct.bar_code)}
                                            disabled={foundProduct.insertQuantity < 1 || isReceiving !== null || disableReceiveStock}
                                            onClick={() => openDamagedDialog(foundProduct)}
                                        >
                                            Dañado
                                        </Button>
                                        <ConfirmDialog
                                            open={openConfirmDialog}
                                            setOpen={setOpenConfirmDialog}
                                            title={damagedDialogText}
                                            description={""}
                                            confirmLabel="Continuar"
                                            onConfirm={() => {
                                                setIsReceiving('-'+foundProduct.bar_code)
                                                handleDamageProducts()
                                            }}
                                            loading={confirmLoading}
                                        />
                                    </td>
                                </tr>
                            }
                            )}
                                        
                        
                        
                            </tbody>
                            </table>
                        </>
                        
                        : 
                        lastScannedProduct.id !== 0 && !exists ? (
                            <>
                            <div className="ml-10">
                                <h1 className="text-lg mb-5 leading-6 font-medium text-gray-900">{i18n.t('replenishments.show_replenishment.product_exists_but_not_in_receipt')}</h1>
                                <div className="block text-sm font-medium text-gray-700 mb-5" >{lastScannedProduct.name} - {getSkus(lastScannedProduct.product_codes)} - {lastScannedProduct.bar_code}</div>
                                <Button
                                    type="primary"
                                    className="mr-2"    
                                    onClick={() => handlAddProductToReplenishment(lastScannedProduct)}
                                >
                                    {i18n.t('replenishments.show_replenishment.add_to_receipt')}
                                </Button>
                            </div>
                            
                            </>
                        )
                        :
                        messageProductsNotFound && !productSearchIsLoading ?
                        (
                                // <div className="ml-10">
                                //     <div className="block text-sm font-medium text-gray-700" >Este producto no esta dado de alta ni en la tienda, ni en el recibo. Contacta un supervisor.</div>
                                // </div>
                                ""
                        )
                        : (
                            ""
                        )
                            
                        } 
                    
                    </div>

                    
                        </section>
                    </main>

                    {/* Post-check-in only (during PROCESSING documents live behind the
                        Documentos header button): facturas and documents each get their
                        own card, separate from the received-pieces table below. */}
                    {supplierInvoiceCaptureEnabled && ['COMPLETED', 'IN_PUTAWAY'].includes(data.replenishment.status) && (
                        <SupplierInvoiceSection replenishmentId={id} invoices={supplierInvoiceNumbers} />
                    )}

                    <aside className="w-full bg-white rounded-lg shadow-sm">
                        <div>
                            <BasicTable
                                columns={exptected_products_table_columns}
                                paginatorLeftTitle="Piezas recibidas"
                                isFetching={isFetching}
                                showLoader={isFetching && isPreviousData}
                                showPaginator
                                showHeader
                                filterable
                                paginationMeta={data?.meta}
                                labelToPaginator="Productos"
                                pagesSize = {pageParams.per_page}
                                onFilterChange={onFilterChange}
                                onPaginationChange= { (requestedPage) => { setPageParams({...pageParams, page: requestedPage}) } }
                                onPageSizeChange= { (pageSize) => {
                                    setPageParams({...pageParams, per_page: pageSize, page: 1})
                                    dispatch(setReplenishmentsProductsListPageSize(pageSize))
                                    tableRef.current.resetPagination()
                                }}
                                data={buildReceivedProductRows(data.replenishment.products).map(product => {
                                    // The correction endpoint's legacy (non-invoice) path is taken whenever the
                                    // row has no factura buckets (capture off, or no facturas on the row) — returns
                                    // always land there, but so does a supplier row without facturas — and it 422s
                                    // on IN_PUTAWAY. COMPLETED blocks both paths. Gate on the path the row will
                                    // actually take, not on is_from_return, so we never offer a link the backend rejects.
                                    const takesLegacyPath = !(supplierInvoiceCaptureEnabled && product.invoice_quantities?.length)
                                    const correctionBlocked = data.replenishment.status === 'COMPLETED' ||
                                        (data.replenishment.status === 'IN_PUTAWAY' && takesLegacyPath)
                                    return {
                                        lot: getLot(product),
                                        name: getName(product),
                                        sku: getSkus(product.product_codes),
                                        upc: product.bar_code,
                                        processed_quantity: getProcessed(product),
                                        ...(supplierInvoiceCaptureEnabled ? { invoice_number: <InvoiceQuantityChips invoiceQuantities={product.invoice_quantities} /> } : {}),
                                        in_reception: (
                                            <span className="inline-flex items-baseline gap-2">
                                                <span>{getInReception(product)}</span>
                                                {!correctionBlocked && (
                                                    <a className="text-xs text-indigo-600 hover:text-indigo-900 cursor-pointer" onClick={() => openCorrectReception(product)}>{i18n.t('replenishments.show_replenishment.correct')}</a>
                                                )}
                                            </span>
                                        ),
                                        quantity: product.quantity
                                    }
                                })}
                                selectable={false}
                                editable={false}
                                ref={tableRef}
                            />
                        </div>
                    </aside>
                </>
                :
                <main className="flex-1 bg-white">
                    <section
                        aria-labelledby="primary-heading"
                        className="min-w-0 flex-1 h-full flex flex-col overflow-hidden min-h-full lg:order-last"
                        style={{minHeight: '75vh'}}
                        >
                        
                        <div className="mx-8 my-5">
                            
                        </div>
                    </section>
                </main>
                }
            </div>
            )}
        </PageView>
    </>)
}